import { useContext } from 'react';
import { ResponsiveConsumer as ResponsiveContext } from 'react-responsive-context';

const useResponsive = () => {
  return useContext(ResponsiveContext);
};

export default useResponsive;
